import { useLocation } from 'react-router-dom';

export default function useURLType() {
  const { pathname } = useLocation();
  // console.log({ pathname })
  // eslint-disable-next-line no-unused-vars
  const [_, __, type, ...rest] = pathname?.split('/') || [];
  return type;
}
